<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="past_streaming" @selected="switchTab"></TabsWidget>
      <div class="tab-options">
      </div>
    </div>
    <div class="wrapper-body">
      <div class="left-panel">
        <div class="streamed-item" v-for="(item, index) in pastStream" :key="index">
          <div class="event-status">
            <b-taglist attached>
              <b-tag type="is-primary" size="is-small" v-if="item.visibility == 'Public'" aria-close-label="Public">
                Public
              </b-tag>
              <b-tag type="is-warning" size="is-small" v-else aria-close-label="Public">
                {{ item.visibility }}
              </b-tag>
              <b-tag v-if="item.status == 'active'" type="is-default" size="is-small" aria-close-label="Active">
                Active
              </b-tag>
            </b-taglist>
          </div>
          <div v-if="item.image" class="streamed-item-image" @click="getStreamSessions(item)">
            <img :src="$store.state.ASSETS_BASE_URL + '/assets/uploaded/' + item.image
              " />
          </div>
          <div v-else class="streamed-item-image" @click="getStreamSessions(item)">
            <img src="@/assets/images/image-not-available.png" />
          </div>
          <div class="stream-header">
            <h3 class="event-title">{{ item.title }}</h3>
            <div class="stream-options">
              <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left" animation="">
                <template #trigger>
                  <b-icon icon="dots-vertical"></b-icon>
                </template>
                <b-dropdown-item v-if="item.status != 'active'" aria-role="listitem"
                  @click="setStreamAsActive(item)">Set As
                  Active</b-dropdown-item>
                <b-dropdown-item @click="showUpdateStreamModal(item)" aria-role="listitem">Update</b-dropdown-item>
                <b-dropdown-item aria-role="listitem" @click="deleteStream(item)">Delete</b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div class="streamed-item-content">
            <div class="streamed-content-left-panel">
              <p class="event-time">
                {{ item.start_date ? moment(item.start_date).format("MMM Do YYYY, h:mm a") : "Time Not Set" }}
              </p>
            </div>
            <div class="streamed-content-right-panel">
              <p class="event-views">{{ $formatNumber(item.views) }} View{{ item.views > 1 ? 's' : '' }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="rigth-panel active_session">
        <div class="rigth-panel-header" v-if="selectedStream">
          <div class="right-panel-tabs">
            <b-tabs v-model="activeSessionTab">
              <b-tab-item label="Streamed session"></b-tab-item>
              <b-tab-item label="Downloads"></b-tab-item>
            </b-tabs>
          </div>

          <div class="stream-session-options" v-if="sessions.length > 0">
            <b-button type="is-primary" outlined @click="showMergeDownloadStreamModal('download')">NEW
              DOWNLOAD</b-button>
            <div class="h-spaceer"></div>
            <b-button type="is-default" outlined @click="showMergeDownloadStreamModal('merge')">MERGE STREAM</b-button>
          </div>
        </div>
        <div v-if="activeSessionTab == 0" class="rigth-panel-body">
          <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>

          <div class="ended-session-widget" v-if="sessions.length > 0">
            <div class="ended-session-item" v-for="(item, index) in sessions" :key="index">
              <div class="session-brand">
                <img v-if="item.status == 'merge_pending' || item.status == 'merge_started'" class="session-cover"
                  src="@/assets/images/image-not-available.png" />
                <img v-else :src="stream_cdn_server_url + '/watch.rw/' + item.sessionId + '/preview.webp'"
                  class="session-cover">

                <div class="session-brand-overlay">
                  <button @click="playVideo(item)" class="btn-play">
                    <img src="@/assets/images/icons/play.svg">
                  </button>
                  <div class="video-time" v-if="item.status == 'completed' || item.status == 'uploaded'">
                    {{ toHHMMSS(parseFloat(item.totalRecordTime)) }}
                  </div>
                  <div class="session-dropdown-options">
                    <b-dropdown aria-role="list" animation="">
                      <template #trigger>
                        <b-icon icon="dots-vertical"></b-icon>
                      </template>
                      <b-dropdown-item @click="setAsDefault(item)" aria-role="listitem">Set As Default</b-dropdown-item>
                      <b-dropdown-item @click="deleteStreamVideoSession(item)"
                        aria-role="listitem">Delete</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
              </div>
              <div class="session-middle-options">
                <div class="session-date">
                  <span>{{ moment(item.createdAt).fromNow() }}</span>
                </div>
                <b-taglist attached>
                  <b-tag type="is-primary" size="is-small"
                    v-if="item.status == 'uploaded' || item.status == 'completed'" aria-close-label="Close tag">
                    Completed
                  </b-tag>
                  <b-tag type="is-warning" size="is-small" v-if="item.status == 'progress'"
                    aria-close-label="Close tag">
                    In Progress
                  </b-tag>
                  <b-tag type="is-default" size="is-small" v-if="item.hlsPath == selectedStream.dumpedHlsPath"
                    aria-close-label="Close tag">
                    Default
                  </b-tag>

                  <b-tag type="is-warning" size="is-small"
                    v-if="item.status == 'merge_pending' || item.status == 'merge_started'"
                    aria-close-label="Close tag">
                    Merging
                  </b-tag>

                </b-taglist>
              </div>
              <div class="session-options">
              </div>
            </div>
          </div>
          <widgetNotfound v-else-if="!isLoading && selectedStream" title="No Stream Sessions Found"
            subtitle="No stream sessions found for this event.">
          </widgetNotfound>
          <widgetNotfound v-else-if="!isLoading && !selectedStream" title="No Stream Selected"
            subtitle="Please select a stream to view its sessions.">
          </widgetNotfound>
        </div>

        <div v-if="activeSessionTab == 1" class="rigth-panel-body">
          <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
          <div class="warning-message-widget">
            <b-message title="Warning" type="is-warning" has-icon aria-close-label="Close message">
              Downloads files will be delete after 24 hours based on when they were available for download.
            </b-message>
          </div>
          <div class="download-session-widget" v-if="downloads.length > 0">
            <div class="download-session-item" v-for="(item, index) in downloads" :key="index">
              <div class="download-count">{{ index + 1 }}</div>
              <div class="download-session-content">
                <div class="download-session-title">
                  <h3>{{ selectedStream.title }}_video.mp4</h3>
                </div>
                <div> <b-tag v-if="item.status != 'completed'" type="is-warning" size="is-small"
                    aria-close-label="Close tag">
                    Link Not Available Yet
                  </b-tag></div>
                <div class="file-size" v-if="item.status == 'completed'">
                  <span>{{ fileSizeConvert(item.fileSize) }}</span>
                </div>

                <div class="copy-link">
                  <a v-if="item.status == 'completed'"
                    v-clipboard:copy="media_server_url + '/recorded/' + item.sessionId + '/video.mp4'"
                    v-clipboard:success="onCopy" v-clipboard:error="onCopyError" href="#">Copy Link</a>
                </div>

              </div>
              <div class="session-options">
                <span class="time-from-now" v-if="item.status == 'completed'">{{ moment(item.updatedAt).fromNow()
                  }}</span>
                <b-button type="is-primary" v-if="item.status == 'completed'" outlined
                  @click="downloadStreamSessionWithLink(item)">Download</b-button>

              </div>
            </div>
          </div>
          <widgetNotfound v-else-if="!isLoading && selectedStream" title="No Stream Sessions Found"
            subtitle="No stream sessions found for this event.">
          </widgetNotfound>
          <widgetNotfound v-else-if="!isLoading && !selectedStream" title="No Stream Selected"
            subtitle="Please select a stream to view its sessions.">
          </widgetNotfound>
        </div>

      </div>
    </div>
    <!-- ClapprPlayer -->
    <b-modal v-model="show_player" v-if="selected_video_url" :width="800">
      <div style="height: 500px">
        <ClapprPlayer :src="selected_video_url" :type="'hls'"></ClapprPlayer>
      </div>
    </b-modal>
    <!-- Update Stream Modal -->
    <UpdateStreamModal :stream="selectedStream" v-if="show_update_stream_modal && selectedStream"
      @close="show_update_stream_modal = false" @saved="onStreamUpdated()"></UpdateStreamModal>

    <!-- Merge Stream Modal -->
    <MergeDownloadStreamModal :stream="selectedStream" :sessions="sessions" v-if="show_merge_dw_stream_modal"
      @close="show_merge_dw_stream_modal = false" :type="merge_dw_stream_modal_type" @saved="onStreamProcessingStarted">
    </MergeDownloadStreamModal>
  </div>
</template>

<script>
import TabsWidget from "./components/TabsWidget.vue";
import { MEDIA_SERVER_BASE_URL, STREAMING_CDN_SERVER_BASE_URL, LIVE_STREAMING_CDN_SERVER_BASE_URL } from "@/store/variables.js";
import UpdateStreamModal from "./modals/UpdateStreamModal.vue";
import MergeDownloadStreamModal from "./modals/MergeDownloadStreamModal.vue"
export default {
  components: {
    TabsWidget,
    UpdateStreamModal,
    MergeDownloadStreamModal
  },
  data: () => ({
    activeSessionTab: 0,
    pastStream: [],
    selectedStream: null,
    isLoading: false,
    sessions: [],
    downloads: [],
    selected_video_url: null,
    show_player: false,
    media_server_url: MEDIA_SERVER_BASE_URL,
    stream_cdn_server_url: STREAMING_CDN_SERVER_BASE_URL,
    show_update_stream_modal: false,
    show_merge_dw_stream_modal: false,
    merge_dw_stream_modal_type: "merge"
  }),
  watch: {

  },
  mounted() {
    let vm = this;
    vm.getPastStream();
  },
  beforeDestroy() {
    let vm = this;
  },
  methods: {
    showMergeDownloadStreamModal(type) {
      let vm = this;
      vm.merge_dw_stream_modal_type = type;
      vm.show_merge_dw_stream_modal = true;
    },
    onStreamUpdated() {
      let vm = this;
      vm.show_update_stream_modal = false;
      vm.getPastStream();
    },
    onStreamProcessingStarted() {
      let vm = this;
      vm.show_merge_dw_stream_modal = false;
      vm.getStreamSessions(vm.selectedStream);
    },
    showUpdateStreamModal(item) {
      let vm = this;
      vm.selectedStream = item;
      vm.show_update_stream_modal = true;
    },
    setAsDefault(item) {
      let vm = this;
      vm.$store
        .dispatch("STREAMING_SET_DEFAULT_DEMPED_HLS", {
          event_id: vm.selectedStream.id,
          dumpedHlsPath: item.hlsPath
        })
        .then((response) => {
          vm.selectedStream.dumpedHlsPath = item.hlsPath;
          vm.getStreamSessions(vm.selectedStream);
          vm.$buefy.toast.open({
            message: "Settings updated",
            type: "is-success",
          });
        })
        .catch(({ response }) => {
        });
    },
    playVideo(item) {
      let vm = this;
      vm.selected_video_url = STREAMING_CDN_SERVER_BASE_URL + "/" + item.hlsPath;
      vm.show_player = true;
    },
    getStreamSessions(item) {
      let vm = this;
      vm.isLoading = true;
      vm.selectedStream = item;
      vm.$store
        .dispatch("STREAMING_GET_STREAM_SESSIONS", {
          event_id: item.id
        })
        .then((response) => {
          vm.isLoading = false;
          vm.sessions = response.data;
        })
        .catch(({ response }) => {
          vm.isLoading = false;
        });
      vm.isLoading = true;
      vm.$store
        .dispatch("STREAMING_GET_STREAM_DOWNLOADS", {
          event_id: item.id
        })
        .then((response) => {
          vm.isLoading = false;
          vm.downloads = response.data;
        })
        .catch(({ response }) => {
          vm.isLoading = false;
        });
    },
    getPastStream() {
      let vm = this;
      vm.loading_data = true;
      vm.$store
        .dispatch("STREAMING_GET_PAST_STREAMS")
        .then((response) => {
          vm.loading_data = false;
          vm.pastStream = response.data.return;
        })
        .catch(({ response }) => {
          vm.loading_data = false;
        });
    },
    setStreamAsActive(item) {
      let vm = this;
      vm.$store
        .dispatch("STREAMING_SET_STREAM_ACTIVE", {
          id: item.id
        })
        .then((response) => {
          vm.getPastStream();
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
        })
        .catch(({ response }) => {
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    deleteStream(item) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure? This will delete the stream permanently.`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.$store
              .dispatch("STREAMING_DELETE_STREAM", {
                id: item.id
              })
              .then((response) => {
                vm.getPastStream();
                vm.sessions = [];
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });
    },
    deleteStreamVideoSession(item) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure? This will delete the stream session permanently.`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.$store
              .dispatch("STREAMING_DELETE_STREAM_SESSION", {
                id: item.id
              })
              .then((response) => {
                vm.getStreamSessions(vm.selectedStream);
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });
    },
    downloadStreamSessionWithLink(item) {
      const url = this.media_server_url + '/recorded/' + item.sessionId + '/video.mp4';
      const a = document.createElement('a');
      a.href = url;
      a.download = item.sessionId + '_video.mp4';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    onCopy() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Copy successfully!",
        type: "is-success",
      });
    },
    onCopyError() {
      let vm = this;
      vm.$buefy.toast.open({
        message: "Failed to copy",
        type: "is-danger",
      });
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        white-space: nowrap;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: flex;

    @media (max-width: 780px) {
      flex-direction: column;
      overflow-y: auto;
      background-color: #fff;
    }

    .left-panel {
      height: 100%;
      width: 300px;
      background: #fff;
      display: flex;
      flex-direction: column;
      overflow-y: auto;

      .streamed-item {
        display: flex;
        flex-direction: column;
        width: 100%;
        border-bottom: 1px solid #ddd;
        padding: 20px 10px;
        cursor: pointer;
        position: relative;

        .event-status {
          position: absolute;
          top: 25px;
          left: 16px;
        }

        &:hover {
          background: #f5f5f5;
        }

        .streamed-item-image {
          width: 100%;
          height: 180px;
          background: #ddd;
          border-radius: 5px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 5px;
            object-fit: cover;
          }
        }


        .stream-header {
          padding-top: 10px;
          display: flex;
          align-items: flex-start;

          .event-title {
            font-size: 16px;
            font-weight: 600;
            color: #333;
            margin-bottom: 5px;
            width: calc(100% - 10px);
          }

          .stream-options {
            width: 10px;
          }
        }

        .streamed-item-content {
          display: flex;
          justify-content: space-between;

          .streamed-content-left-panel {
            .event-time {
              font-size: 12px;
              color: #999;
            }
          }

          .streamed-content-right-panel {
            .event-views {
              font-size: 12px;
              color: #999;
            }
          }
        }
      }
    }

    .rigth-panel {
      width: calc(100% - 300px);
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;

      @media (max-width: 530px) {
        position: absolute;
        background: white;
        z-index: 10;
        top: 0px;
        right: -800px;
        width: 85%;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);
        transition: .5s;
      }

      &.active_session {
        @media (max-width: 530px) {
          right: 0;
        }
      }


      .rigth-panel-header {
        height: 55px;
        display: flex;
        align-items: center;
        padding-right: 20px;
        border-bottom: 1px solid #ddd;
        border-top: 1px solid #ddd;
        justify-content: space-between;
        top: 0;
        background: white;

        .right-panel-tabs {
          height: 100%;
          position: relative;
          top: -7px;
        }

        .stream-session-options {
          display: flex;
          align-items: center;

          .h-spaceer {
            width: 10px;
          }
        }

      }

      .rigth-panel-body {
        height: calc(100% - 55px);
        display: flex;
        flex-direction: column;
        position: relative;
        overflow-y: auto;

        .ended-session-widget {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          justify-items: stretch;
          align-content: start;
          gap: 10px;
          padding: 10px;

          .ended-session-item {
            display: flex;
            justify-content: space-between;
            height: max-content;
            padding: 10px 10px;
            border: 1px solid #ddd;
            border-radius: 5px;

            &:hover {
              border: 1px solid #e0e0e0;
              background-color: #fafafa;
            }

            .session-brand {
              position: relative;
              height: 100px;

              .session-cover {
                width: 180px;
                height: 100%;
                object-fit: cover;
              }

              .session-brand-overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: rgba(0, 0, 0, 0.5);
                transition: all 0.3s ease;

                .btn-play {
                  width: 50px;
                  height: 50px;
                  border-radius: 50%;
                  background: #fff;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  transition: all 0.3s ease;

                  &:hover {
                    background: #ddd;
                  }
                }

                .video-time {
                  color: #fff;
                  font-size: 12px;
                  margin-left: 10px;
                  position: absolute;
                  bottom: 5px;
                  right: 5px;

                }

                .session-dropdown-options {
                  position: absolute;
                  top: 5px;
                  right: 5px;
                  color: #fff;
                }
              }
            }

            .session-options {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: flex-end;
              height: 100%;
              padding: 10px 0;

              .file-size {
                font-size: 12px;
                color: #999;
              }
            }

          }
        }

        .download-session-widget {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          justify-items: stretch;
          align-content: start;
          gap: 10px;
          padding: 10px;

          .download-session-item {
            display: flex;
            align-items: center;
            height: max-content;
            padding: 10px 10px;
            border: 1px solid #ddd;
            border-radius: 5px;

            &:hover {
              border: 1px solid #e0e0e0;
              background-color: #fafafa;
            }

            .download-count {
              font-size: 24px;
              font-weight: 600;
              color: #333;
              margin-right: 10px;

            }

            .download-session-content {
              display: flex;
              flex-direction: column;
              width: 100%;

              .download-session-title {
                h3 {
                  font-size: 16px;
                  font-weight: 600;
                  color: #333;
                  margin-bottom: 5px;
                }
              }

              .file-size {
                font-size: 12px;
                color: #999;
              }
            }

            .session-options {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: flex-end;
              height: 100%;
              padding: 10px 0;

              .time-from-now {
                font-size: 12px;
                color: #999;
              }
            }

          }
        }

      }
    }
  }
}
</style>
